import { Controller } from "@hotwired/stimulus";

/**
 * <div class="selected-item">を制御する
 * @example
 * <div data-controller="selected-item">
 *   選択された項目
 *   <button data-action="selected-item#remove">解除</button>
 * </div>
 * @example 他のフォームのチェックボックスをオフにする
 * <div data-controller="selected-item">
 *   <button
 *     data-action="selected-item#remove
 *     selected-item#uncheck"
 *     data-selected-item-selector-param="#form input[name=id][value=1]">
 *   >解除</button>
 */
export class SelectedItemController extends Controller {
  /** これを取り除く */
  remove() {
    this.element.remove();
  }

  /** selectorが差すチェックボックスを解除する */
  uncheck(event) {
    const selector = event.params.selector;
    if (!selector) return;
    const checkbox = document.querySelector(selector);
    if (!checkbox) return;
    checkbox.checked = false;
  }
}
